import { Box, Skeleton } from "@mui/material";
import "../styles/dashboard.scss";

const KpiCardSkeleton = () => (
  <Box className="kpi-card-skeleton">
    <Box className="kpi-card-skeleton__header">
      <Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: '9px', flexShrink: 0 }} animation="wave" />
      <Skeleton variant="text" width="55%" height={14} animation="wave" />
    </Box>
    <Skeleton variant="text" width="42%" height={30} sx={{ marginBottom: '4px' }} animation="wave" />
  </Box>
);

export default KpiCardSkeleton;